module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"site":"Markt","department":"Abteilung","givenName":"Vorname","email":"E-Mail-Adresse","familyName":"Nachname","tenant":"Mandant"},"en":{"site":"Site","department":"Department","givenName":"Given name","email":"Email","familyName":"Family name","tenant":"Tenant"}}')
  delete Component.options._Ctor
}
